import { Student } from "../../providers/studentsProvider";
import { LatestActivitiesCard } from "../student/cards/LatestActivitiesCard";
import { LatestInvoicesCard } from "../student/cards/LatestInvoicesCard";
import { TrainingsCard2 } from "./cards/TrainingsCard2";
import { StudentTab } from "../student/StudentTab";
import { useBookedQuotes } from "../../hooks/useBookedQuotes";
import { TheoryProgressCard } from "../student/cards/TheoryProgressCard";
import { PaymentsCard } from "../student/cards/PaymentsCard";

export function StudentOverviewTab2(props: { student: Student; trainingIncludesTheoryLessonsOrExam: boolean }) {
  const { student, trainingIncludesTheoryLessonsOrExam } = props;
  const { selectedBookedQuote } = useBookedQuotes(student);

  return (
    <StudentTab>
      <>
        <TrainingsCard2 student={student} selectedBookedQuote={selectedBookedQuote} />
        <div style={{ height: "20px" }} />
        <LatestActivitiesCard student={student} filter={{ bookedTrainingIds: selectedBookedQuote.bookedTrainingIds }} />
      </>
      <>
        {trainingIncludesTheoryLessonsOrExam && (
          <>
            <TheoryProgressCard student={student} selectedBookedQuote={selectedBookedQuote} />
            <div style={{ height: "20px" }} />
          </>
        )}
        <PaymentsCard student={student} />
        <div style={{ height: "20px" }} />
        <LatestInvoicesCard student={student} />
      </>
    </StudentTab>
  );
}
